import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import { withTranslation } from "react-i18next";

import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';

//Elements
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const content = {
    title: {
      line1: "Spy everything.",
      line2: "Explode your results."
    },
    paragraph: "Best Influencers, winning product Snapchat, Facebook. You'll see it all",
    button: [{
        title: "Login"
      },
      {
        title: "Discover",
      }
    ]
  };

  const t = props.t;

  // video modal :
  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }
  // end ---

  return (
    <section
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              {t(content.title.line1)}
              <br/>
              <span className="text-color-primary">
                {t(content.title.line2)}
              </span>
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                {t(content.paragraph)}
                </p>
              <div className="reveal-from-bottom" data-reveal-delay="600">

                <Button tag="a" color="primary" wideMobile target='_blank' href="https://app.ecomspy.io/">
                  {t(content.button[0].title)}
                </Button>
                <Link to="/signup">
                  <Button color="dark" wideMobile target='_blank' style={{margin : '5px 10px'}}>
                      {t(content.button[1].title)}
                  </Button>
                </Link>

              </div>
            </div>
          </div>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            <a
              data-video="https://www.youtube.com/embed/c_qEeFLhUNM"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/images/saas_videoplaceholder.png')}
                alt="Hero-img"
                width={600}
              />
            </a>
          </div>
          <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://www.youtube.com/embed/c_qEeFLhUNM"
            videoTag="iframe" />
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default withTranslation()(Hero);
